import React from 'react'
import _ from 'lodash'
import { FormattedDate, FormattedMessage } from 'react-intl'
import { ROWS_PER_PAGE_DEFAULT } from '../constants/common'

const auxFunction = {
  checkHasValue: (data) => (data !== null || undefined ? data : ''),
  convertStringFloat: (str) => {
    const result = parseFloat(str.replace(',', '.'))
    return Number.isNaN(result) ? '' : result
  },
  parseDate: (date) => {
    const format = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
    }
    return <FormattedDate value={date} {...format} />
  },
  parseFloat: (num, dec) =>
    dec === undefined ? parseFloat(num) : parseFloat(num).toFixed(dec),
  parseDateAndHour: (date) => {
    const format = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
    }
    return date && <FormattedDate value={date} {...format} />
  },
  sendPriceNotifications: (rowData) => {
    let val = ''
    if (_.has(rowData?.send, 'api')) val = 'API-MINETUR'
    if (_.has(rowData?.send, 'web')) val = 'WEB'
    if (_.has(rowData?.send, 'sms')) val = 'SMS'
    return val
  },
  pricesReportedBy: (rowData) => {
    const val = rowData.notification.service ? (
      <FormattedMessage id="service" />
    ) : (
      rowData?.notification?.user?.name
    )

    const getSeverity = () => {
      if (rowData.notification?.service) return 'success'
      return 'info'
    }

    return { val, severity: getSeverity() }
  },
  isIterable: (obj) =>
    obj != null && typeof obj[Symbol.iterator] === 'function',
}

export default auxFunction
